<!-- <p-dialog #dialog [header]="file?.fileName" styleClass="vs-modal force-full-width file-viewer" [showHeader]="false" positionBottom="0" positionTop="0" [(visible)]="showFileDialog" [style]="{'bottom':'0'}" [contentStyle]="{'height': '100vh'}" [modal]="true" [maximizable]="true" appendTo="body"> -->
    <div class="modal-body">
        <div class="fileinfo">{{file?.fileName}}</div>
        <a *ngIf="listFile?.length > 0" (click)="onPrev()" class="ui-state-default ui-lightbox-nav-left ui-corner-right"><span class="ui-lightbox-nav-icon pi pi-chevron-left"></span></a>

        <div *ngIf="file.type == fileType.Video" class="box-content">
            <video controls="" autoplay="" name="media">
                <source [src]="file?.link" type="video/{{file.extention.replace('.','')}}">
            </video>
        </div>

        <div *ngIf="file.type == fileType.Image" class="box-content" #container>
            <div class="image-container" (mousedown)="onMouseDown($event, image)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp()">
                <img #image [src]="getImageOriginal(file?.id)"
                    [ngStyle]="{ transform: 'scale(' + scale / 100 + ') translate(' + offsetX + 'px, ' + offsetY + 'px) rotate(' + rotation + 'deg)',
                    'transform-origin': 'center center'}" draggable="false">
            </div>
            <div>
                <div  *ngIf="isShowDestroyConfirm" class="total-sale-display">
                    <span *ngIf="modelBrowseImg.totalSale">{{modelBrowseImg.totalSale | vsnumber : 0}} đ</span>
                </div>
                <!-- [authorize]="{'dapfood.api': { productAdsCheckInController: 64 }}" -->
                <div *ngIf="optionBrowse != -1" class="confirm-btn">
                    <button class="vs-btn vs-btn-green" (click)="confirmImage()">
                        <span class="__icon fa-light fa-check-circle"></span>
                        <span class="__label">Duyệt</span>
                    </button>
                </div>

                <div *ngIf="isShowDestroyConfirm" class="destroy-btn">
                    <button class="vs-btn vs-btn-red" (click)="DestroyConfirmDisplay(false)">
                        <span class="__label">Không duyệt</span>
                    </button>
                </div>

                <div class="rotate-controls">
                    <button pTooltip="Xoay trái" (click)="rotateImage(-90)"><i class="fa-light fa-undo"></i></button>
                    <button pTooltip="Xoay phải" (click)="rotateImage(90)"><i class="fa-light fa-redo"></i></button>
                </div>
            </div>
        </div>
          
        <a *ngIf="listFile?.length > 0" (click)="onNext()" class="ui-state-default ui-lightbox-nav-right ui-corner-left"><span class="ui-lightbox-nav-icon pi pi-chevron-right"></span></a>

        <a (click)="closePopup()" class="btnClose"><span class="pi pi-times"></span></a>
    </div>

    <div class="list_img" *ngIf="listFile?.length > 0">
        <div *ngFor="let item of listFile; let idx = index" class="img" [ngClass]="{'active': idx === selectedIndex}">
            <img *ngIf="item.type == fileType.Image" style="width: 60px;height: 100%;" [src]="getImageAvatar(item.id)" (click)="getCurrent(item, idx)" (contextmenu)="openPopup($event, item)">
        </div>
    </div>

    <div *ngIf="isPopupVisible && idPharmacy > 0" class="popup-menu" [ngStyle]="{'top.px': popupPosition.y, 'left.px': popupPosition.x}">
        <div class="command-container">
            <div *ngFor="let command of commands" class="btn-command" (click)="command_option(command.label, command.action, file)">
                {{ command.label }}
            </div>
        </div>
    </div>

<!-- </p-dialog> -->

<p-dialog header="Lý do" [(visible)]="isShowRejectReason" [modal]="false" [closable]="false" [style]="{width: '400px', 'z-index': '1006'}">
    <div class="p-fluid">
        <div class="p-field">
            <label for="reason">Nhập lý do không duyệt</label>
            <textarea id="reason" [(ngModel)]="rejectReason" rows="4" style="width: 100%"></textarea>
        </div>
    </div>
    <div class="p-dialog-footer">
        <button class="vs-btn vs-btn-blue mr-10" (click)="submitRejectReason()">Xác nhận</button>
        <button class="vs-btn vs-btn-default" (click)="isShowRejectReason = false">Hủy</button>
    </div>
</p-dialog>
